import { useState, useEffect, useContext } from "react";
import { useCambioInstalacion } from "./useCambioInstalacion";
import { DataContext } from "../../contextData/contextData";
import ErrorInput from "../../components/ui/ErrorInput";
import { InputSelect } from "../../components/formComponents/inputSelect";
import Spinner from "../../components/ui/Spinner";

export const CambioDeInstalacion = props => {
  const { unidadesNegocio, getUnidadesNegocio, instalaciones, getInstalaciones } = useCambioInstalacion();
  const [buscando, setBuscando] = useState(false);
  const { uno } = useContext(DataContext);
  const [instalacion, setInstalacion] = useState("");
  const { formik } = props;

  // document.addEventListener("mousedown", function (event) {
  //   console.log(event.target);
  // });

  const funciocita = async () => {
    if (formik.values.unidad_destino) {
      setBuscando(true);
      await getInstalaciones(formik.values.unidad_destino);
      setBuscando(false);

      formik.setValues({ ...formik.values, instalacion_administrador: "" });
      const inputCont = document.querySelector("div#instalacion_administrador");

      if (inputCont) {
        const btn_X = inputCont.querySelector(".limpiarSelect__indicator>svg");
        const event = new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window });

        btn_X.dispatchEvent(event);
      }
    }
  };

  useEffect(() => {
    // if (formik.values.unidad_destino) {
    //   setBuscando(true);
    //   await getInstalaciones(formik.values.unidad_destino);
    //   setBuscando(false);
    //   formik.setValues({ ...formik.values, instalacion_administrador: "" });
    //   const inputCont = document.querySelector("div#instalacion_administrador");
    //   if (inputCont) {
    //     const btn_X = inputCont.querySelector(".limpiarSelect__indicator>svg");
    //     const event = new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window });
    //     btn_X.dispatchEvent(event);
    //   }
    // }
    funciocita();
  }, [formik.values.unidad_destino]);

  useEffect(() => {
    getUnidadesNegocio();
  }, []);

  useEffect(() => {
    setInstalacion(formik.values.instalacion_administrador["NOMBRE_UO"]);

    // console.log(formik.values.instalacion_administrador["NOMBRE_UO"]);
  }, [formik.values.instalacion_administrador]);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between">
          <label htmlFor="unidad_destino">Unidad de negocio *</label>
          {formik.errors.unidad_destino !== undefined && formik.touched.unidad_destino !== undefined && <ErrorInput touched={formik.touched.unidad_destino} error={formik.errors.unidad_destino} />}
        </div>

        <select disabled={!formik.values.fecha_inicio_cambio || formik.errors.fecha_inicio_cambio} id="unidadNegocio" className="form-select" name="unidad_destino" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.unidad_destino}>
          <option value="">Seleccione</option>
          {unidadesNegocio.map((el, idx) => (
            <option value={el.id} key={idx}>
              {el.nombre}
            </option>
          ))}
        </select>
      </div>
      <div>
        {!buscando ? (
          <>
            <div className="d-flex justify-content-between">
              <label htmlFor="instalacion_administrador">Instalación *</label>
              {formik.errors.instalacion_administrador !== undefined && formik.touched.instalacion_administrador !== undefined && <ErrorInput touched={formik.touched.instalacion_administrador} error={formik.errors.instalacion_administrador} />}
            </div>
            <InputSelect llave_texto="NOMBRE_UO" id="instalacion_administrador" llave_valor={null} formik={formik} arr={instalaciones} />
          </>
        ) : (
          <div style={{ columnGap: "10px" }} className="d-flex align-items-center justify-content-center flex-row">
            <p style={{ fontSize: "17px" }} className="mb-2">Cargando instalaciones</p>
            <Spinner clases="m-2 p-2" />
          </div>
        )}

        {/* <select
          disabled={!formik.values.fecha_inicio_cambio || formik.errors.fecha_inicio_cambio}
          id="instalacion_administrador"
          className="form-select"
          name="instalacion_administrador"
          aria-label="Default select example"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.instalacion_administrador}
        >
          <option value="">Seleccione</option>
          {instalaciones.map((el, idx) => (
            <option
              value={JSON.stringify(el)}
              key={idx}
              className={`${[el["JEFE"], el["ADMIN"], el["REVISOR_RRHH"]].includes(null) ? "text-desactivado" : ""}`}
            >
              {el["NOMBRE_UO"]}
            </option>
          ))}
        </select> */}
      </div>
    </>
  );
};
